import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import Head from "next/head";
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import i18next from "i18next";
import { useStore } from "@dp/state";
import { useRouter } from "next/router";
var ReservationsComp = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.Reservations;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    },
    modules: ["reservations/index.tsx -> " + "@dp/xcomp"]
  }
});

var ReservationsPage = function ReservationsPage() {
  var _router$query;

  var store = useStore();
  var router = useRouter();
  var confirmationNumber = router.query.confirmationNumber;
  var reservationDate = router.query.reservationDate;
  var action = router.query.action;
  var restaurantNumber = router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.setRestaurant;

  var _useRouter = useRouter(),
      query = _useRouter.query;

  var isMyReservationsTabActive = (query === null || query === void 0 ? void 0 : query.tab) === "my-reservations";
  useEffect(function () {
    store.initComponent("Reservations").then(function () {
      // NOOP
      if (isMyReservationsTabActive) {
        store.reservation.reservationModel.tabReserveTable = false;
      }
    });
  }, []);
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("title", {
        children: i18next.t("title.reservations.pagetitle", {
          defaultValue: "Restaurant Reservations"
        })
      })
    }), /*#__PURE__*/_jsx(ReservationsComp, {
      confirmationNumber: confirmationNumber,
      action: action,
      reservationDate: reservationDate,
      restaurantNumber: restaurantNumber
    })]
  });
};

ReservationsPage.layout = PageLayout.NB_LAYOUT;
ReservationsPage.layoutProps = {
  showJoinWaitListHeader: true
};
export default observer(ReservationsPage);